import React from "react";
import "./Preloader.css";

const Preloader = () => {
  return <div className="circle-preloader" aria-label="Loading"></div>;
};

export default Preloader;
